module.exports = __webpack_public_path__ + "static/media/port_marker_dark_blue.5f7ad8fb.svg";